


// document.addEventListener('DOMContentLoaded', function () {

//   const megaMenus = document.querySelectorAll('.custom-mega-menu');
//   if (!megaMenus.length) return;

//   const headerNav = document.querySelector('.bdb-header__nav');
//   if (!headerNav) return;

//   const subTitleEl = document.getElementById('mega-sub-title');
//   const prodTitleEl = document.getElementById('mega-products-title');

//   // Convert text to handle
//   const toHandle = (text) =>
//     text.toLowerCase().trim().replace(/\s+/g, '-');

//   const hideAllMegaMenus = () => {
//     megaMenus.forEach(menu => menu.classList.remove('is-active'));
//   };

//   const isDesktop = () =>
//     window.matchMedia('(min-width: 990px)').matches;

//   // MENU ITEM HOVER
//   headerNav.querySelectorAll('.bdb-header__nav-link')
//     .forEach(link => {

//       const label = link.querySelector('.bdb-header__nav-label');
//       if (!label) return;

//       const handle = toHandle(label.textContent);

//       const relatedMegaMenu = document.querySelector(
//         `.custom-mega-menu[data-menu="${handle}"]`
//       );

//       if (!relatedMegaMenu) return;

//       link.addEventListener('mouseenter', () => {
//         if (!isDesktop()) return;

//         hideAllMegaMenus();
//         relatedMegaMenu.classList.add('is-active');
//       });
//     });

//   // Keep mega menu open on hover
//   megaMenus.forEach(menu => {
//     menu.addEventListener('mouseenter', () => {
//       if (!isDesktop()) return;
//       menu.classList.add('is-active');
//     });

//     menu.addEventListener('mouseleave', () => {
//       if (!isDesktop()) return;
//       menu.classList.remove('is-active');
//     });
//   });

//   // ===== Column 1 → Column 2 sync =====
//   document.querySelectorAll('.mega-main-item').forEach(mainItem => {
//     mainItem.addEventListener('mouseenter', () => {

//       const handle = mainItem.dataset.handle;
//       if (!handle) return;

//       // 1. Active state for column 1
//       document.querySelectorAll('.mega-main-item')
//         .forEach(item => item.classList.remove('active'));
//       mainItem.classList.add('active');

//       // 2. Show correct sub-collection (column 2)
//       document.querySelectorAll('.mega-sub-collections')
//         .forEach(ul => ul.classList.remove('active'));

//       const relatedSub = document.querySelector(
//         `.mega-sub-collections[data-parent="${handle}"]`
//       );

//       if (relatedSub) {
//         relatedSub.classList.add('active');

//         // Update sub-collection title (column 2)
//         if (subTitleEl) subTitleEl.textContent = mainItem.textContent;

//         // Activate first sub-item and products by default
//         const firstSubItem = relatedSub.querySelector('.mega-sub-item');
//         if (firstSubItem) {

//           document.querySelectorAll('.mega-sub-item')
//             .forEach(item => item.classList.remove('active'));
//           firstSubItem.classList.add('active');

//           const firstHandle = firstSubItem.dataset.subHandle;
//           if (firstHandle) {
//             document.querySelectorAll('.mega-products')
//               .forEach(prod => prod.classList.remove('active'));

//             const relatedProducts = document.querySelector(
//               `.mega-products[data-products="${firstHandle}"]`
//             );
//             if (relatedProducts) {
//               relatedProducts.classList.add('active');

//               // Update products title (column 3)
//               if (prodTitleEl) prodTitleEl.textContent = firstSubItem.textContent;
//             }
//           }
//         }
//       }
//     });
//   });

//   // ===== Column 2 → Column 3 sync =====
//   document.querySelectorAll('.mega-sub-item').forEach(subItem => {

//     subItem.addEventListener('mouseenter', () => {

//       const handle = subItem.dataset.subHandle;
//       if (!handle) return;

//       // 1. Active state for sub collections
//       document.querySelectorAll('.mega-sub-item')
//         .forEach(item => item.classList.remove('active'));
//       subItem.classList.add('active');

//       // 2. Show matching products
//       document.querySelectorAll('.mega-products')
//         .forEach(prod => prod.classList.remove('active'));

//       const relatedProducts = document.querySelector(
//         `.mega-products[data-products="${handle}"]`
//       );

//       if (relatedProducts) {
//         relatedProducts.classList.add('active');

//         // Update products title (column 3)
//         if (prodTitleEl) prodTitleEl.textContent = subItem.textContent;
//       }
//     });

//   });

//   // ===== Default activation for Column 3 (on load) =====
//   (function activateDefaultProducts() {

//     const firstActiveSubList = document.querySelector(
//       '.mega-sub-collections.active'
//     );
//     if (!firstActiveSubList) return;

//     const firstSubItem = firstActiveSubList.querySelector('.mega-sub-item');
//     if (!firstSubItem) return;

//     const handle = firstSubItem.dataset.subHandle;
//     if (!handle) return;

//     // Mark sub item active
//     document.querySelectorAll('.mega-sub-item')
//       .forEach(item => item.classList.remove('active'));
//     firstSubItem.classList.add('active');

//     // Show matching products
//     document.querySelectorAll('.mega-products')
//       .forEach(prod => prod.classList.remove('active'));

//     const relatedProducts = document.querySelector(
//       `.mega-products[data-products="${handle}"]`
//     );

//     if (relatedProducts) {
//       relatedProducts.classList.add('active');

//       // Set products title (column 3)
//       if (prodTitleEl) prodTitleEl.textContent = firstSubItem.textContent;
//     }

//   })();

// });

// SECOND wokring JS

document.addEventListener('DOMContentLoaded', function () {

  const megaMenus = document.querySelectorAll('.custom-mega-menu');
  if (!megaMenus.length) return;

  const headerNav = document.querySelector('.bdb-header__nav');
  if (!headerNav) return;

  // const subTitleEl = document.getElementById('mega-sub-title');
  // const prodTitleEl = document.getElementById('mega-products-title');

  const toHandle = (text) =>
    text.toLowerCase().trim().replace(/\s+/g, '-');

  const hideAllMegaMenus = () => {
    megaMenus.forEach(menu => menu.classList.remove('is-active'));
  };

  const isDesktop = () =>
    window.matchMedia('(min-width: 990px)').matches;

  // ================= Header Menu Hover =================
  headerNav.querySelectorAll('.bdb-header__nav-link').forEach(link => {

    const label = link.querySelector('.bdb-header__nav-label');
    if (!label) return;

    const handle = toHandle(label.textContent);
    const relatedMegaMenu = document.querySelector(
      `.custom-mega-menu[data-menu="${handle}"]`
    );

    if (!relatedMegaMenu) return;

    link.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      hideAllMegaMenus();
      relatedMegaMenu.classList.add('is-active');
    });
  });

// new code aapended to fix
// Hide mega menu when hovering other nav items
headerNav.querySelectorAll('.bdb-header__nav-item').forEach(item => {

  item.addEventListener('mouseenter', () => {

    const link = item.querySelector('.bdb-header__nav-link');
    if (!link) return;

    const label = link.querySelector('.bdb-header__nav-label');
    if (!label) return;

    const handle = toHandle(label.textContent);

    const relatedMegaMenu = document.querySelector(
      `.custom-mega-menu[data-menu="${handle}"]`
    );

    if (!relatedMegaMenu) {
      hideAllMegaMenus();
    }

  });

});


  megaMenus.forEach(menu => {
    menu.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      menu.classList.add('is-active');
    });

    menu.addEventListener('mouseleave', () => {
      if (!isDesktop()) return;
      menu.classList.remove('is-active');
    });
  });

  // ================= Column 1 → Column 2 → Column 3 =================
  document.querySelectorAll('.mega-main-item').forEach(mainItem => {

    // HOVER
    mainItem.addEventListener('mouseenter', () => {
      const handle = mainItem.dataset.handle;
      if (!handle) return;

      document.querySelectorAll('.mega-main-item')
        .forEach(i => i.classList.remove('active'));
      mainItem.classList.add('active');

      // document.querySelectorAll('.mega-sub-collections')
      //   .forEach(ul => ul.classList.remove('active'));

      // const relatedSub = document.querySelector(
      //   `.mega-sub-collections[data-parent="${handle}"]`
      // );
      const currentMegaMenu = mainItem.closest('.custom-mega-menu');

currentMegaMenu.querySelectorAll('.mega-sub-collections')
  .forEach(ul => ul.classList.remove('active'));

const relatedSub = currentMegaMenu.querySelector(
  `.mega-sub-collections[data-parent="${handle}"]`
);

      if (!relatedSub) return;
      relatedSub.classList.add('active');

      // if (subTitleEl) subTitleEl.textContent = mainItem.textContent;
const subTitleEl = currentMegaMenu.querySelector('.mega-col-2 .mega-col-title');

if (subTitleEl) subTitleEl.textContent = mainItem.textContent;

      const firstSub = relatedSub.querySelector('.mega-sub-item');
      if (!firstSub) return;

      activateSubItem(firstSub);
    });

    // CLICK → navigate
    mainItem.addEventListener('click', () => {
      const url = mainItem.dataset.url;
      if (url) window.location.href = url;
    });
  });

  // ================= Column 2 → Column 3 =================
  document.querySelectorAll('.mega-sub-item').forEach(subItem => {

    // HOVER
    subItem.addEventListener('mouseenter', () => {
      activateSubItem(subItem);
    });

    // CLICK → navigate
    subItem.addEventListener('click', () => {
      const url = subItem.dataset.url;
      if (url) window.location.href = url;
    });
  });

  // ================= Helper =================
  function activateSubItem(subItem) {
    const handle = subItem.dataset.subHandle;
    if (!handle) return;

    document.querySelectorAll('.mega-sub-item')
      .forEach(i => i.classList.remove('active'));
    subItem.classList.add('active');

    // document.querySelectorAll('.mega-products')
    const currentMegaMenu = subItem.closest('.custom-mega-menu');

currentMegaMenu.querySelectorAll('.mega-products')
      .forEach(p => p.classList.remove('active'));

    // const relatedProducts = document.querySelector(
    const relatedProducts = currentMegaMenu.querySelector(
      `.mega-products[data-products="${handle}"]`
    );

    if (relatedProducts) relatedProducts.classList.add('active');
    // if (prodTitleEl) prodTitleEl.textContent = subItem.textContent;
    const prodTitleEl = currentMegaMenu.querySelector('.mega-col-3 .mega-col-title');

    if (prodTitleEl) prodTitleEl.textContent = subItem.textContent;
  }

  // ================= Default Load =================
  const firstActiveSubList = document.querySelector('.mega-sub-collections.active');
  if (firstActiveSubList) {
    const firstSub = firstActiveSubList.querySelector('.mega-sub-item');
    if (firstSub) activateSubItem(firstSub);
  }

});



// document.addEventListener('DOMContentLoaded', function () {

//   /* =========================
//      BASIC SETUP
//   ========================== */

//   const megaMenus = document.querySelectorAll('.custom-mega-menu');
//   if (!megaMenus.length) return;

//   const headerNav = document.querySelector('.bdb-header__nav');
//   if (!headerNav) return;

//   const isDesktop = () =>
//     window.matchMedia('(min-width: 990px)').matches;

//   const toHandle = (text) =>
//     text.toLowerCase().trim().replace(/\s+/g, '-');

//   const hideAllMegaMenus = () => {
//     megaMenus.forEach(menu => menu.classList.remove('is-active'));
//   };

//   /* =========================
//      HEADER MENU → MEGA MENU
//   ========================== */

//   headerNav.querySelectorAll('.bdb-header__nav-link')
//     .forEach(link => {

//       const label = link.querySelector('.bdb-header__nav-label');
//       if (!label) return;

//       const handle = toHandle(label.textContent);

//       const relatedMegaMenu = document.querySelector(
//         `.custom-mega-menu[data-menu="${handle}"]`
//       );

//       if (!relatedMegaMenu) return;

//       link.addEventListener('mouseenter', () => {
//         if (!isDesktop()) return;

//         hideAllMegaMenus();
//         relatedMegaMenu.classList.add('is-active');

//         // Ensure correct defaults when opening
//         activateDefaultState(relatedMegaMenu);
//       });
//     });

//   /* =========================
//      KEEP MEGA MENU OPEN
//   ========================== */

//   megaMenus.forEach(menu => {

//     menu.addEventListener('mouseenter', () => {
//       if (!isDesktop()) return;
//       menu.classList.add('is-active');
//     });

//     menu.addEventListener('mouseleave', () => {
//       if (!isDesktop()) return;
//       menu.classList.remove('is-active');
//     });

//   });

//   /* =========================
//      COLUMN 1 → COLUMN 2
//   ========================== */

//   document.querySelectorAll('.mega-main-item').forEach(mainItem => {

//     mainItem.addEventListener('mouseenter', () => {

//       const megaMenu = mainItem.closest('.custom-mega-menu');
//       if (!megaMenu) return;

//       const handle = mainItem.dataset.handle;
//       if (!handle) return;

//       // Active main item
//       megaMenu.querySelectorAll('.mega-main-item')
//         .forEach(i => i.classList.remove('active'));
//       mainItem.classList.add('active');

//       // Show related sub collections
//       megaMenu.querySelectorAll('.mega-sub-collections')
//         .forEach(ul => ul.classList.remove('active'));

//       const relatedSub = megaMenu.querySelector(
//         `.mega-sub-collections[data-parent="${handle}"]`
//       );

//       if (relatedSub) {
//         relatedSub.classList.add('active');

//         // Auto-activate first sub-collection
//         const firstSub = relatedSub.querySelector('.mega-sub-item');
//         if (firstSub) {
//           activateSubCollection(firstSub, megaMenu);
//         }
//       }
//     });

//   });

//   /* =========================
//      COLUMN 2 → COLUMN 3
//   ========================== */

//   document.querySelectorAll('.mega-sub-item').forEach(subItem => {

//     subItem.addEventListener('mouseenter', () => {

//       const megaMenu = subItem.closest('.custom-mega-menu');
//       if (!megaMenu) return;

//       activateSubCollection(subItem, megaMenu);
//     });

//   });

//   /* =========================
//      FUNCTIONS
//   ========================== */

//   function activateSubCollection(subItem, megaMenu) {

//     const handle = subItem.dataset.subHandle;
//     if (!handle) return;

//     // Active sub item
//     megaMenu.querySelectorAll('.mega-sub-item')
//       .forEach(i => i.classList.remove('active'));
//     subItem.classList.add('active');

//     // Show products
//     megaMenu.querySelectorAll('.mega-products')
//       .forEach(p => p.classList.remove('active'));

//     const relatedProducts = megaMenu.querySelector(
//       `.mega-products[data-products="${handle}"]`
//     );

//     if (relatedProducts) {
//       relatedProducts.classList.add('active');
//     }
//   }

//   function activateDefaultState(megaMenu) {

//     // First main collection
//     const firstMain = megaMenu.querySelector('.mega-main-item');
//     if (!firstMain) return;

//     firstMain.classList.add('active');

//     const parentHandle = firstMain.dataset.handle;

//     // First sub collection list
//     const firstSubList = megaMenu.querySelector(
//       `.mega-sub-collections[data-parent="${parentHandle}"]`
//     );

//     if (!firstSubList) return;

//     firstSubList.classList.add('active');

//     const firstSubItem = firstSubList.querySelector('.mega-sub-item');
//     if (!firstSubItem) return;

//     activateSubCollection(firstSubItem, megaMenu);
//   }

// });
